import { useCurrencyContext } from '../contexts/CurrencyContext';
import { CURRENCIES, getCurrency } from '../lib/currencies';

export function useCurrency() {
  const ctx = useCurrencyContext();
  return { ...ctx, currencies: CURRENCIES, getCurrency };
}
